import useEnvironment from './useEnvironment';

const useDataTestsEnabled = (envId?: string) =>
  !!useEnvironment(envId)?.flags?.dataTestsEnabled;

export default useDataTestsEnabled;
